import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "introducrion" }
const _hoisted_4 = {
  href: "https://www.linkedin.com/",
  class: "linkedINlogo",
  target: "_blank"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "text name" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "description" }

import { ref, watch, inject } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'TeamsSection',
  setup(__props) {

const store: any = inject(`store`);
const displayWidth: any = inject(`displayWidth`);
const router: any = inject(`router`);
const cardData = store.getters.getTeamCardData;
const wrapper = ref();
const columnsQuantity = ref();

watch([displayWidth, wrapper], () => {
  if (wrapper.value.clientWidth < 630) {
    columnsQuantity.value = `containerSmall`;
  } else if (wrapper.value.clientWidth < 980) {
    columnsQuantity.value = `containerMedium`;
  } else{
    columnsQuantity.value = `containerBig`;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_SectionHeader = _resolveComponent("SectionHeader")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("section", {
    ref_key: "wrapper",
    ref: wrapper
  }, [
    _createVNode(_component_SectionHeader, {
      title: "Team",
      id: "team",
      text: "Meet the skilled and experienced team behind our successful digital marketing strategies"
    }),
    _createElementVNode("div", {
      class: _normalizeClass([`container`,columnsQuantity.value])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cardData), (card) => {
        return (_openBlock(), _createBlock(_component_BaseCard, {
          styleProp: "white",
          key: card.name
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("img", {
                class: "photo",
                src: card.image,
                alt: card.alt
              }, null, 8, _hoisted_2),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("a", _hoisted_4, [
                  _createElementVNode("img", {
                    src: require(`../assets/SocialIcon.png`),
                    alt: "LinkedIn icon"
                  }, null, 8, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, _toDisplayString(card.name), 1),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(card.work), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(card.descrription), 1)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ], 2),
    _createVNode(_component_BaseButton, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ path: `/Team`, query: { name: `Team` } }))),
      color: "black",
      center: false,
      class: "button",
      ref: "button",
      style: _normalizeStyle({ minWidth: columnsQuantity.value===`containerSmall`?`100%`:`0`}),
      text: "See all team"
    }, null, 8, ["style"])
  ], 512))
}
}

})